import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";

import AppFooter from "../components/AppFooter.jsx";
import AppHeader from "../components/AppHeader.jsx";
import AppLayout from "../components/AppLayout.jsx";

import i18n from "../i18n.js";
import { selectCurrentUser } from "../store/index";
import referralsApi from "../api/referrals.js";
import { sendError } from "../errors.js";
import { setLoading } from "../store";
import TalentReferralSection from "../components/partnerProgramPage/TalentReferralSection.jsx";

export default function ReferralPage() {
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser);
  const [referralLink, setReferralLink] = useState("");

  if (!user) {
    window.location.href = "/login";
    return;
  }
  if (!user.talentPool) {
    window.location.href = "/app";
    return;
  }

  useEffect(async () => {
    dispatch(setLoading(true));
    try {
      const { talentReferralLink } = await referralsApi.referralLinks();
      setReferralLink(talentReferralLink);
    } catch (err) {
      sendError(err);
    }
    dispatch(setLoading(false));
  }, []);

  return (
    <AppLayout
      header={<AppHeader title={i18n.t("pages.titles.referral")} />}
      footer={<AppFooter />}
    >
      {referralLink && <TalentReferralSection referralLink={referralLink} />}
    </AppLayout>
  );
}
